export default __webpack_public_path__ + "static/GRID22-how-to-read-data-disasters-es-76bd397e82852229fcf364cdc5a406e7.png";